<span class="message">A new version is out! Please refresh the page.</span>
<button class="button" mat-flat-button (click)="refreshPage()" color="accent">Refresh</button>
